module.exports = "images/11ans.ebe3f9e9.png";